import { Grid, Typography } from '@mui/material';
import RetroHeadings from './RetroHeadings';

type RetrospectivesProps = {
  isCompanyConfig?: boolean;
};

function Retrospectives({ isCompanyConfig = false }: RetrospectivesProps) {
  return (
    <Grid container spacing={2} mb={3}>
      <Grid item sm={12}>
        <Typography variant="h4" mb={1}>
          Retrospectives
        </Typography>
        <RetroHeadings isCompanyConfig={isCompanyConfig} />
      </Grid>
    </Grid>
  );
}

export default Retrospectives;
